import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

import { Modal } from "components/ui/source";

import styles from "./SlideUpModal.module.scss";

export const SlideUpModal = ({ children, className, isOpen, onClose }) => {
  return (
    <Modal
      modalProps={{
        className: classNames(className, styles.container),
        isOpen,
        onRequestClose: onClose,
      }}
    >
      <Modal.Close onClick={onClose} />

      {children}
    </Modal>
  );
};

SlideUpModal.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};
